const baseURL = 'https://solutions.api-services.cloud/api-ccpisa-appointments/'

// const baseURL = 'http://localhost:3283/'

export const getOffices = (): string => {
    return baseURL + 'offices'
}

export const getServices = (officeId: number): string => {
    return baseURL + 'office/' + officeId + '/services'
}

export const getServiceTimeSlots = (serviceId: number): string => {
    return baseURL + 'service/' + serviceId + '/slots'
}

export const createEvent = (serviceId: number): string => {
    return baseURL + 'service/' + serviceId + '/event'
}

export const checkReCaptcha = (): string => {
    return baseURL + 'recaptcha'
}

export const getEmailTemplateInfo = (): string => {
    return baseURL + 'conf'
}

export const getUserAppoinments = (userToken: string): string => {
    return baseURL + 'appointments/' + userToken
}

export const removeUserAppointment = (idService: string): string => {
    return baseURL + '/service/' + idService + '/delete-event'
}
